import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { useLanguage } from "../i18n/LanguageContext";

const Setores = () => {
  const { t } = useLanguage();
  const s = t.sectors;
  const sectors = t.home.sectors;
  return (
    <div data-testid="sectors-page">
      <PageHero eyebrow={s.eyebrow} title={s.title} intro={s.intro} testid="sectors-hero" />

      <section className="border-b border-synergia-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-testid="sectors-grid">
            {sectors.map((sec, i) => (
              <div
                key={sec.title}
                className="bg-synergia-greenLight border-l-2 border-synergia-green p-10 md:p-12 flex flex-col transition-colors duration-300 hover:bg-synergia-greenSoft"
                data-testid={`sectors-item-${i}`}
              >
                <div className="font-montserrat font-semibold text-synergia-gold text-sm tracking-widest">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <h3 className="mt-5 font-montserrat font-semibold text-2xl md:text-3xl text-synergia-green leading-snug text-balance">
                  {sec.title}
                </h3>
                <div className="h-[2px] w-14 bg-synergia-gold mt-8" />
                <p className="mt-8 font-inter text-base md:text-lg leading-relaxed text-synergia-graphite/80">
                  {sec.text}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-20">
            <Link to="/contato" className="btn-primary" data-testid="sectors-cta">
              {t.nav.contactCta} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Setores;
